export const CREATE_WORKER_UPAD = 'CREATE_WORKER_UPAD';
export const GET_WORKER_UPAD = 'GET_WORKER_UPAD';
export const WORKER_UPAD_REQUEST = 'WORKER_UPAD_REQUEST';
export const UPDATE_WORKER_UPAD = 'UPDATE_WORKER_UPAD';
export const DELETE_WORKER_UPAD = 'DELETE_WORKER_UPAD';
export const WORKER_UPAD_REQUEST_FAILURE = 'WORKER_UPAD_REQUEST_FAILURE';